var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      staticClass: "table",
      attrs: {
        data: _vm.trackingLogs,
        size: "mini",
        "highlight-current-row": "",
        "header-cell-style": { fontWeight: "bold" },
      },
    },
    [
      _c("el-table-column", {
        attrs: { prop: "statusDesc", label: "服务状态" },
      }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "description", label: "描述" } }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "operatorName", label: "操作人" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "operationTime", label: "操作时间" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }